import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'preview'];

  connect() {
    this.baseUrl = this.previewTarget.textContent.replace(/[^/]*$/, '');
  }

  updatePreview() {
    const newNick = this.inputTarget.value;
    this.previewTarget.textContent = this.baseUrl + newNick;
  }
}
